/**
 * A World encapsulates the declarative blueprint for an experience: who owns it,
 * which scene it maps to, and how to build its contents/environment. World keeps
 * this contract lightweight so registries and orb strategies can evolve without
 * embedding rendering or traversal logic directly inside the class.
 */
export class World {
    constructor(options) {
        var _a;
        const rawSlug = (_a = options.slug) !== null && _a !== void 0 ? _a : '';
        const normalizedSlug = rawSlug.trim().toLowerCase();
        if (!normalizedSlug) {
            const fallback = `world-${Date.now().toString(36)}-${Math.floor(Math.random() * 1e4).toString(36)}`;
            console.warn('[World] Received empty slug; generating fallback identifier', {
                original: rawSlug,
                fallback,
            });
            this.slug = fallback;
        }
        else {
            this.slug = normalizedSlug;
        }
        this.label = options.label.trim() || this.slug;
        const desiredSceneName = options.sceneName ? options.sceneName.trim() : this.slug;
        this.sceneName = desiredSceneName || this.slug;
        this.buildFn = options.build;
        console.log('[World] Constructed world definition', {
            slug: this.slug,
            label: this.label,
            sceneName: this.sceneName,
        });
    }
    build(contextScene) {
        this.buildFn({ scene: contextScene, world: this });
    }
}
